<div *ngIf="!(loading | async); else loadingRef">
  <div class="faq-container">
    <ng-container *ngIf="faqSections$ | async as faqSections">
      <ng-container *ngFor="let faqSection of faqSections">
        <fgbcl-faq-section-card [faqSection]="faqSection"></fgbcl-faq-section-card>
      </ng-container>
    </ng-container>
  </div>
</div>
<ng-template #loadingRef>
  <div class="w-100 mt-5">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
